import { useScrollLock } from '@vueuse/core';

import { stateFactoryKey, type StateFactory } from '@/injectionKeys';
import type { SEARCH_EXPERIENCES_MODAL, EXPERIENCE_DETAIL_IMAGE_MODAL, EXPERIENCE_GALLERY_MODAL } from '@/utils/state';

type ModalName = typeof SEARCH_EXPERIENCES_MODAL | typeof EXPERIENCE_DETAIL_IMAGE_MODAL | typeof EXPERIENCE_GALLERY_MODAL;

export const useGlobalModal = (modalName: ModalName) => {
  const stateFactory = inject(stateFactoryKey) as StateFactory;
  const isOpen = stateFactory.create<boolean>(modalName, false);

  const bodyElementRef = ref<HTMLElement | null>(null);
  onMounted(() => {
    bodyElementRef.value = document.body;
  });
  const isBackgroundLocked = useScrollLock(bodyElementRef);

  const open = async ({ autoClose } = { autoClose: false }) => {
    isOpen.value = true;

    if (!autoClose) return;

    setTimeout(() => {
      isOpen.value = false;
    }, 3000);
  };

  const close = async () => {
    isOpen.value = false;
  };

  watch([isOpen], () => {
    isBackgroundLocked.value = isOpen.value; // Modalが開いている間は、背景をスクロールできないようにする
  });

  return { isOpen, open, close };
};
